import { Box, Divider, Typography } from '@wishket/design-system';

import { ListItem } from '@/shared/Components';
import { AuthorEmployment } from '@/shared/types';

const EmploymentListItem = ({
  isFreelancer,
  companyName,
  workingCompanyName,
  clientName,
}: AuthorEmployment) => {
  return (
    <ListItem>
      <Typography variant="contents2" className="text-w-gray-700">
        {isFreelancer ? '프리랜서' : companyName}
      </Typography>
      {workingCompanyName && (
        <Box className="flex items-center gap-3">
          <Divider isVertical className="hidden h-4 desktop:block" />
          <Typography
            variant="body1"
            className="w-[62px] font-medium text-w-gray-600 desktop:w-fit"
          >
            근무 회사
          </Typography>
          <Typography variant="body1" className="text-w-gray-600">
            {workingCompanyName}
          </Typography>
        </Box>
      )}
      {clientName && (
        <Box className="flex items-center gap-3">
          <Divider isVertical className="hidden h-4 desktop:block" />
          <Typography
            variant="body1"
            className="w-[62px] font-medium text-w-gray-600 desktop:w-fit"
          >
            고객사
          </Typography>
          <Typography variant="body1" className="text-w-gray-600">
            {clientName}
          </Typography>
        </Box>
      )}
    </ListItem>
  );
};

export default EmploymentListItem;
